// firebaseInstance.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

import { firebaseConfig } from "./variable";

// Initialize app
export const app = initializeApp(firebaseConfig);

// Services
const FIREDB = getDatabase(app);
const FIRESTORAGE = getStorage(app);

export { FIREDB, FIRESTORAGE };
